/* eslint-disable */
import { Workbox } from 'workbox-window';

// TODO Need to remove console once code freezing is completed
const promptForUpdate = () => {
	return new Promise((resolve) => {
		const confirmation = window.confirm('New update available. Do you want to update?');
		console.log('User response to update prompt:', confirmation);
		resolve(confirmation);
	});
};

let wbInstance = null;

export const checkForUpdates = () => {
	// trigger a service worker update check when Workbox is already registered.
	// Prevent page refresh on the login page
	if (wbInstance) {
		wbInstance.update();
		console.log('Checked for service worker updates');
	}
	// if (navigator?.serviceWorker?.controller) {
	// 	navigator.serviceWorker.controller.postMessage({ type: 'CHECK_FOR_UPDATES' });
	// 	console.log('Sent CHECK_FOR_UPDATES message to service worker');
	// }
};

const register = () => {
	if ('production' !== process.env.NODE_ENV) {
		return;
	}

	if ('serviceWorker' in navigator) {
		console.log('Service Worker is supported');
		const wb = new Workbox('/service-worker.js');
		wbInstance = wb;

		let refreshing = false;
		let reloadOnControllerChange = false;

		navigator.serviceWorker.addEventListener('controllerchange', () => {
			if (reloadOnControllerChange && !refreshing) {
				refreshing = true;
				console.log('Controller changed, reloading page');
				window.location.reload();
			}
		});

		wb.addEventListener('waiting', async (event) => {
			console.log('New service worker is waiting');
			const updateAccepted = await promptForUpdate();
			if (updateAccepted) {
				console.log('Update accepted, skipping waiting');
				reloadOnControllerChange = true;
				wb.messageSkipWaiting();
			}
		});

		wb.addEventListener('controlling', (event) => {
			console.log('Service worker is now controlling');
		});

		wb.register()
			.then((registration) => {
				console.log('Service Worker registered successfully:', registration);
				registration.update();
			})
			.catch((error) => {
				console.error('Service Worker registration failed:', error);
			});
	}
};

export { register };
